import { render } from "./CompleteFormView.vue?vue&type=template&id=40dff5da"
import script from "./CompleteFormView.vue?vue&type=script&lang=js"
export * from "./CompleteFormView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Emertat\\Desktop\\p\\nazerhelp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__